// eslint-disable-next-line import/prefer-default-export
import { ZoneChargeSchema } from '@b2ag/types-api-schemas'

export function mapFromApi({ zone_id: zoneId, cost }: ZoneChargeSchema = {}) {
  return { zoneId, cost }
}
